import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PosTakePhotoComponent } from './pos-take-photo.component';



@NgModule({
  declarations: [PosTakePhotoComponent],
  imports: [
    CommonModule,
    ModalModule
  ]
})
export class PosTakePhotoModule { }
